// Sidecar implementation ofthe CpaasPlatformUserService
// Instead of providing this service in Root, we'll provide it in the sidecar app

import { Injectable, inject } from '@angular/core';
import { LoginService } from '@nuso/auth/data-access';
import { CpaasPortalUser, CpaasUserService } from '@nuso/cpaas/data-access';
import { Observable, map, filter} from 'rxjs';

@Injectable()
export class PortalCpaasUserService implements CpaasUserService {
  private loginService = inject(LoginService);


  public currentCpaasPortalUser(): Observable<CpaasPortalUser | null> {
    return this.loginService.currentUser()
      .pipe(
        filter(user => !!user),
        map(user => ({
          id: user.id,
          name: user.name,
          isAdmin: user.isAdmin,
          isReseller: user.isReseller,
        })),
      )
  }
}

